import * as React from "react";
/**
 * Simple layout for pages that have tables. Common styling.
 * @param {object} props
 * @param {React.children} props.children
 * @returns {JSX.Element}
 */
export function ListPageLayout({ children }) {
  return <div style={{ margin: "10px" }}>{children}</div>;
}
